import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Users } from "lucide-react";
import { api } from "@/lib/api";
import { SectionHead, Reveal } from "@/components/Reveal";

export const fmtDate = (iso) =>
  new Date(iso + "T00:00:00").toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "short" });

export default function UpcomingSessions() {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    api.get("/public/sessions").then((r) => setSessions(r.data.slice(0, 3))).catch(() => {});
  }, []);

  if (!sessions.length) return null;

  return (
    <section data-testid="upcoming-sessions-section" className="bg-zinc-950 border-y border-zinc-800/70 py-24 sm:py-32 px-5 sm:px-10 lg:px-16">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
        <SectionHead overline="Group training">
          Train with <span className="text-stroke">Capable 360.</span>
        </SectionHead>
        <Link
          to="/sessions"
          data-testid="view-all-sessions-link"
          className="group inline-flex items-center gap-2 text-volt text-xs uppercase tracking-[0.18em] font-bold hover:text-white transition-colors"
        >
          View upcoming group sessions <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
        </Link>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        {sessions.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.07}>
            <Link
              to="/sessions"
              data-testid={`session-preview-${s.id}`}
              className="group block h-full border border-zinc-800 bg-ink p-7 hover:border-volt/60 transition-colors duration-500"
            >
              <p className="text-[10px] uppercase tracking-[0.22em] text-volt font-bold">{fmtDate(s.date)}</p>
              <h3 className="font-display uppercase text-3xl mt-2 leading-none">{s.time}</h3>
              <p className="mt-3 text-sm text-zinc-400 flex items-center gap-2"><MapPin size={14} className="text-zinc-600" /> {s.location}</p>
              <p className="mt-1 text-sm text-zinc-400">Focus: <span className="text-zinc-200">{s.focus}</span></p>
              <div className="mt-6 flex items-center justify-between border-t border-zinc-800 pt-4">
                <span className="flex items-center gap-2 text-xs uppercase tracking-[0.16em] text-zinc-400">
                  <Users size={14} className="text-volt" /> {s.available} / {s.capacity} spots
                </span>
                <span className="text-xs uppercase tracking-[0.16em] font-bold text-zinc-300 group-hover:text-volt transition-colors">
                  {s.available > 0 ? "Reserve →" : "Waitlist →"}
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
